if (window.NodeList && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = Array.prototype.forEach;
}
// Create Element.remove() function if not exist
if (!('remove' in Element.prototype)) {
  Element.prototype.remove = function() {
    if (this.parentNode) {
      this.parentNode.removeChild(this);
    }
  };
}
window.appSearchSelect = window.appSearchSelect || (function () {

  const S_SEARCH_SELECT = '.js-search-select'
  const W               = window
  const D               = document;

  function getDefaultStore () {
    return {
      selects: [],
      timeout: null
    }
  }

  let store = {}

  function on (el, event, cb) {
    if (el) {
      event.split(' ').forEach(function (e) {
        el.removeEventListener(e, cb)
        el.addEventListener(e, cb)
      })
    }
  }

  function updateWidth (parent) {
    if(!parent){
      return true
    }
    parent.style.width = '100%'
    setTimeout(function () {
      parent.style.width = (parent.clientWidth + 1) + 'px'
    }, 100)
  }

  function resize () {
    if (store.selects.length) {
      clearTimeout(store.timeout)
      store.timeout = setTimeout(function () {
        store.selects.forEach(function (v) {
          !v.multiple && updateWidth(v.formGroup)
        })
      }, 300)
    }
  }

  function constructorSelect (elem) {

    elem.classList.remove('select--ssr')
    elem.classList.remove('selectr-hidden')

    let formGroup     = elem.parentElement
    let selectrSSR = formGroup.querySelector('.selectr--ssr')
    if (selectrSSR) {
      selectrSSR.remove()
    }
    let placeholder   = elem.getAttribute('data-placeholder')
    elem.selectSearch = new W.selectr(elem, {
      placeholder: placeholder || "Выбрать параметр",
      messages:    {
        noResults:     "Не найдено.",
        maxSelections: "Можно выбрать не более {max} элементов.",
        tagDuplicate:  "Этот тег уже используется",
      }
    })
    elem.formGroup = formGroup
    !elem.multiple && updateWidth(formGroup)
    return elem
  }

  function init () {
    if (!W.selectr) {
      on(D, 'selectr:init', init)
      return true
    }
    store = getDefaultStore()
    D.querySelectorAll(S_SEARCH_SELECT).forEach(function (v) {
      if (v.classList.contains('select--ssr')) {
        store.selects.push(constructorSelect(v))
      } else {
        store.selects.push(v)
      }
    })
    on(W, 'resize', resize)
  }

  init()
  return {
    init
  }
})()
